import { FunctionComponent, h } from 'preact';
import { isNil as _isNil } from 'lodash';
import { observer } from 'mobx-react';
import { useCallback, useState } from 'preact/hooks';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import bringgDefaultLogo from '../../../assets/bringg-logo-app.svg';
import MerchantLogo from '../../../components/merchant-logo/merchant-logo';
import PoweredByLogo from '../../../components/svg-components/powered-by-svg';
import { useTranslation } from '../../../hooks/use-translation';
import { getIconVisibility } from '../../../helpers/aria-helper';
import { useStore } from '../../../helpers/use-store';
import SharedLocationSideNav from '../sidenav/shared-location-side-nav';

interface Props {
	merchantLogo?: string;
}

// TODO: remove when doing new API refactor
export const OLD_BRINGG_LOGO = '/images/logo.png';
const isOldBringgLogo = (merchantLogo: string) => merchantLogo.includes(OLD_BRINGG_LOGO);

const SharedLocationHeader: FunctionComponent<Props> = ({ merchantLogo }) => {
	const { t } = useTranslation();
	const { ariaStore } = useStore();
	const shouldUseBringgLogo = _isNil(merchantLogo) || isOldBringgLogo(merchantLogo);
	const merchantLogoUrl = shouldUseBringgLogo ? bringgDefaultLogo : merchantLogo;

	const [isSideNavOpen, setIsSideNavOpen] = useState<boolean>(false);

	const openSideNav = useCallback(() => {
		setIsSideNavOpen(true);
		ariaStore.setIsModalOpen(true);
	}, [ariaStore]);

	const closeSideNav = useCallback(() => {
		setIsSideNavOpen(false);
		ariaStore.setIsModalOpen(false);
	}, [ariaStore]);

	return (
		<div className="shared-location-header" data-testid="shared-location-header">
			<button
				aria-label={t('OPEN_MENU')}
				onClick={openSideNav}
				style={getIconVisibility(!isSideNavOpen && !ariaStore.isModalOpen)}
				className={'menu'}
				tabIndex={isSideNavOpen || ariaStore.isModalOpen ? -1 : 0}
			>
				<BringgIcon iconName={BringgFontIcons.Hamburger} />
			</button>
			<MerchantLogo className="merchant-logo-header" merchantLogoUrl={merchantLogoUrl} />
			<PoweredByLogo className="powered-by-logo" />
			<SharedLocationSideNav
				isOpen={isSideNavOpen}
				onClose={closeSideNav}
				merchantLogoUrl={merchantLogoUrl}
				aria-hidden={ariaStore.isModalOpen}
				openSideNav={openSideNav}
			/>
		</div>
	);
};

export default observer(SharedLocationHeader);
